import { localStorageHelper } from '../../../../utils/localStorageHelper'

const MAX_RECENTS = 5

function lastViewKey (userId) {
  return `portfolioExplorer.${userId}.lastViewId`
}

function recentViewsKey (userId) {
  return `portfolioExplorer.${userId}.recentViews`
}

export function getLastViewId (userId) {
  return localStorageHelper.tryLoad(lastViewKey(userId))
}

export function setLastViewId (userId, id) {
  localStorageHelper.tryStore(lastViewKey(userId), id ?? null)
}

export function getRecentViews (userId) {
  return localStorageHelper.tryLoad(recentViewsKey(userId)) || []
}

export function pushRecentView (userId, id, name) {
  if (id == null || !name) return
  const recents = getRecentViews(userId).filter(r => r.id !== id)
  recents.unshift({ id, name })
  localStorageHelper.tryStore(recentViewsKey(userId), recents.slice(0, MAX_RECENTS))
}
